// extracted by mini-css-extract-plugin
module.exports = {"DomainOrSkillPage__bg":"DomainOrSkillPage_DomainOrSkillPage__bg__0_lxe","DomainOrSkillPage__foundersGradient":"DomainOrSkillPage_DomainOrSkillPage__foundersGradient__PoMbg"};